import React from 'react';
import { motion } from 'framer-motion';
import { RevealItem, revealContainer } from '../common/Reveal';
import { PageHeader } from '../layout/PageHeader';
import { TeamSelect } from '../common/TeamSelect';
import { SegmentedControl } from '../common/SegmentedControl';
import { SearchInput } from '../common/SearchInput';
import { SourceFilter } from '../common/SourceFilter';
import { EmptyState } from '../common/EmptyState';
import { PodiumCard } from '../leaderboard/PodiumCard';
import { LeaderboardTable } from '../leaderboard/LeaderboardTable';
import { BlandLoTable } from '../bland/BlandLoTable';
import { PacesetterList } from '../floor/PacesetterList';
import { dateLabel } from '../../utils/floor';
import { rangeOptions, scopeLabels } from '../../utils/range';
import { sourceLabel } from '../../utils/sources';
import type { CallsInsightHubState } from '../CallsInsightHub/useCallsInsightHub';
export function LeaderboardView({
  hub
}: {
  hub: CallsInsightHubState;
}) {
  const isBland = hub.source === 'bland';
  const podium = hub.rows.filter(r => r.rank <= 3);
  const rest = hub.rows.filter(r => r.rank > 3);
  const subtitle = isBland ? `Ranked by opportunities created from Bland transfers, ${scopeLabels[hub.range]}` : `Ranked by time on ${sourceLabel(hub.source)} calls, ${scopeLabels[hub.range]}`;
  return <>
      <PageHeader title="Leaderboard" subtitle={subtitle} data-id="element-777" data-mp="3n4l1g8rj8kd6" />

      <RevealItem className="mb-6 flex flex-col gap-3 md:flex-row md:items-center" data-id="element-778" data-mp="5tbk2sy13th1">
        <div className="flex flex-wrap items-center gap-3" data-id="element-779" data-mp="w1wzjy43twd">
          <SourceFilter value={hub.source} onChange={hub.setSource} data-id="element-780" data-mp="tfnvfvkp6c1" />
          <TeamSelect value={hub.team} onChange={hub.setTeam} data-id="element-781" data-mp="em5dduab8tdw" />
          <SegmentedControl label="Date range" options={rangeOptions} value={hub.range} onChange={hub.setRange} data-id="element-782" data-mp="aktj3bghrjzd" />
        </div>
        <div className="md:ml-auto" data-id="element-783" data-mp="olmd7v2vsd1y">
          <SearchInput value={hub.query} onChange={hub.setQuery} data-id="element-784" data-mp="oii2eeuwuj2b" />
        </div>
      </RevealItem>

      {isBland ? hub.blandRows.length === 0 ? <EmptyState data-id="element-785" data-mp="3df162nwrarzu" /> : <RevealItem data-id="element-786" data-mp="3dbwuh5gyotz5">
            <BlandLoTable rows={hub.blandRows} title="Loan officer rankings" data-id="element-787" data-mp="3hete8zi8mw4o" />
          </RevealItem> : hub.rows.length === 0 ? <EmptyState data-id="element-788" data-mp="3mcuuzds6yjcz" /> : <motion.div variants={revealContainer} className="flex flex-col gap-6" data-id="element-789" data-mp="3r54kwttb3jf9">
          <motion.div variants={revealContainer} className="grid gap-6 xl:grid-cols-[minmax(0,1fr)_minmax(320px,0.42fr)]" data-id="element-790" data-mp="3r77ka4gcmown">
            {podium.length > 0 && <motion.section variants={revealContainer} aria-label="Top performers" className="grid gap-4 md:grid-cols-3" data-id="element-791" data-mp="4wv3pktjqm0g">
                {podium.map(row => <RevealItem key={row.agent.id} fill data-id="element-792" data-mp="dycjf231klom">
                    <PodiumCard row={row} onSelect={hub.setSelectedId} data-id="element-793" data-mp="dxtd6imr7lqf" />
                  </RevealItem>)}
              </motion.section>}
            <RevealItem fill data-id="element-794" data-mp="2fp67kdr3ib88">
              <PacesetterList snapshot={hub.floor} dateLabel={`Five9 · ${dateLabel(hub.floorDate)}`} onSelect={hub.setSelectedId} data-id="element-795" data-mp="2fq7srb1tse3o" />
            </RevealItem>
          </motion.div>
          {rest.length > 0 && <RevealItem data-id="element-796" data-mp="23dn8n5ldzehf">
              <LeaderboardTable rows={rest} onSelect={hub.setSelectedId} data-id="element-797" data-mp="1ygdni2515oze" />
            </RevealItem>}
        </motion.div>}
    </>;
}